// Tiny indirection for product analytics events.
//
// Be Bold ships without a vendor (Mixpanel / Amplitude / PostHog /
// etc.) wired in. Components call `track('event_name', props)` so the
// call sites are already in place; when we are ready to commit, hook
// up a real provider once at app boot:
//
//   import posthog from 'posthog-js';
//   posthog.init('<key>', { api_host: '...' });
//   setAnalytics({
//     track: (name, props) => posthog.capture(name, props),
//     identify: (id, traits) => posthog.identify(id, traits),
//   });
//
// Until then, calls are no-ops so the app works without keys.
//
// Naming convention for events: `<surface>_<action>` in snake_case.
// Examples already in use:
//   - tour_started, tour_completed, tour_dismissed
//   - app_guide_opened, app_guide_section_tapped, app_guide_closed
//   - route_hint_dismissed
//   - whats_new_opened
//
// Props should be small, flat objects of primitives. No PII.

let provider = null;

export function setAnalytics(p) {
  provider = (p && typeof p.track === 'function') ? p : null;
}

export function track(event, props) {
  if (!provider) return;
  try {
    provider.track(event, props || {});
  } catch {
    // Analytics errors must never break the user's flow.
  }
}

export function identify(userId, traits) {
  if (!provider || typeof provider.identify !== 'function') return;
  try {
    provider.identify(userId, traits || {});
  } catch {}
}
